import PropTypes from 'prop-types';
import React from 'react';
import { withEnums } from '../../../decorators';
import Dropdown from './Dropdown';

function ReasonOfRequestDropdown(_ref) {
  var value = _ref.value,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      reasonsOfRequest = _ref.reasonsOfRequest,
      regionName = _ref.regionName,
      classNamePrefix = _ref.classNamePrefix;

  if (!reasonsOfRequest || !regionName || !reasonsOfRequest[regionName]) {
    return null;
  }

  var countryReasons = Object.keys(reasonsOfRequest[regionName]);
  var reasonOptions = countryReasons.map(function (reason) {
    return {
      label: reason,
      value: reason
    };
  });
  return React.createElement(Dropdown, {
    isClearable: true,
    placeholder: placeholder,
    options: reasonOptions,
    value: value,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    classNamePrefix: classNamePrefix
  });
}

ReasonOfRequestDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  regionName: PropTypes.oneOf(['ccs', 'argentina', 'brazil', 'mexico']),
  reasonsOfRequest: PropTypes.shape({
    ccs: PropTypes.object,
    argentina: PropTypes.object,
    brazil: PropTypes.object,
    mexico: PropTypes.object
  })
};
ReasonOfRequestDropdown.defaultProps = {
  regionName: 'brazil',
  placeholder: 'Reason of request',
  classNamePrefix: 'SearchableDropdown'
};
export default withEnums('reasonsOfRequest')(ReasonOfRequestDropdown);